import { render, staticRenderFns } from "./MainTemplate.vue?vue&type=template&id=7f32969b&"
import script from "./MainTemplate.vue?vue&type=script&lang=js&"
export * from "./MainTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports